import { render, staticRenderFns } from "./updateContent.vue?vue&type=template&id=ab5665c2&scoped=true"
import script from "./updateContent.vue?vue&type=script&lang=js"
export * from "./updateContent.vue?vue&type=script&lang=js"
import style0 from "./updateContent.vue?vue&type=style&index=0&id=ab5665c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5665c2",
  null
  
)

export default component.exports